<template>
    <div>
        <div class="text-right mb-3">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t('header.post')" @click="showModal(false, {})">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t('header.post')}}</span>
            </button>
        </div>
        <div class="panel mb-0">
            <div class="panel-hdr d-block pt-4 p-3">
                <div class="row mb-2">
                    <div class="col-sm-12 col-md-12 mb-2">
                        <b-form-group  v-slot="{ ariaDescribedby }">
                            <b-form-radio-group class="mb-2"
                                id="postDateFilterRadio"
                                v-model="selectedDateFilter"
                                :options="radDateFilter"
                                :aria-describedby="ariaDescribedby"
                                name="postDateFilterRadio"
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div v-if="selectedDateFilter != 'all'" class="col-sm-12 col-md-4 mb-2">
                        <date-range-picker class="w-100"
                            ref="picker"
                            v-model="dateRange"
                            :opens="'right'"
                            :autoApply="true"
                            :showDropdowns="true" 
                            :always-show-calendars="false"
                            :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                            @showCustomRange="showCustomRangeCalendars=true"
                            @update="filterByDate">
                        </date-range-picker>
                    </div>
                    <div v-if="selectedTab != 'all'" class="col-sm-12 col-md-4 mb-2">
                        <div class="form-group">
                            <label class="form-label">{{$t('table.header.type')}}</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-tag"></i>
                                    </label>
                                    <multiselect  
                                        v-model="selectedType" 
                                        :options="postType" 
                                        group-values="type" group-label="category" 
                                        track-by="id" label="text" 
                                        :show-labels="false" 
                                        openDirection="below" 
                                        @select="filterByType">
                                        <span slot="noResult">{{$t('table.no_records')}}</span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 mb-2">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0" >
                                        <i class="fas fa-user"></i>
                                    </label>
                                    <multiselect v-model="selectedStylist" label="text" track-by="id" :options="stylist" :searchable="false" :show-labels="false" openDirection="below" @select="filterByStylist"></multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 mb-2">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0" >
                                        <i class="fas fa-comment-alt"></i>
                                    </label>
                                    <multiselect v-model="selectedPost" :placeholder="$t('subMenu.my_salon_tukang') + $t('header.post')" label="title" track-by="id" :options="posts" :option-height="104" :show-labels="false" @select="filterByPost">
                                        <template slot="singleLabel" slot-scope="props">
                                            <span class="option__desc"><span class="option__title">{{ props.option.title }}</span></span>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span v-if="props.option.id != 'all'" class="option__title d-block">{{'ID: ' + props.option.id }}</span>
                                                <span class="option__title d-block text-primary fw-500">{{ props.option.title == "" ? '-' : props.option.title }}</span>
                                                <span class="option__small fw-300 text-muted">{{ props.option.desc }}</span>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a class="link text-primary ml-3" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
            </div>
            <div class="panel-container pb-3">
                <div class="panel-content">
                    <ul class="nav nav-tabs mb-3">
                        <li class="nav-item" v-for="t in postCategory" :key="t.id">
                            <a class="nav-link bg-transparent fs-md" :class="{'active': selectedTab == t.id}" @click="filterByCategory(t.id)">
                                <img v-if="t.id != 'all'" class="img-fluid img-social mr-2 border-radius" :src="require('./tukangCategory/' + t.id + '.png')"/>
                                {{t.text}}
                            </a>
                        </li>
                    </ul>
                    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                        {{$t('table.no_records')}} {{$t('message.info.add_tukang', {'item': $t('header.post')})}}
                    </div>
                    <div class="mt-5" v-if="!isSpinnerShow && totalEntries != 0">
                        <div class="mb-3 w-100 d-flex justify-content-end">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend min-width-20">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-sort-alt"></i>
                                        </label>
                                        <multiselect  
                                            v-model="selectedSortOption" 
                                            :options="sortOption" 
                                            track-by="id" label="text" 
                                            :show-labels="false" 
                                            :searchable="false"
                                            openDirection="below" 
                                            @select="sortPost">
                                            <span slot="noResult">{{$t('table.no_records')}}</span>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination_short', {'totalEntries': totalEntries})}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="postItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>
                                        <template #cell(TkPostCreateDate)="data">
                                            {{convertTimestampToDateTime(data.item.TkPostCreateDate)}}
                                        </template>
                                        <template #cell(message)="data">
                                            <a class="text-primary link"  :title="$t('button_link.send_message')" @click="showMessageModal(data.item)">
                                                <i class="fal fa-comment-lines"></i>
                                            </a>
                                        </template>
                                        <template #cell(TkPostImage)="data">
                                            <b-carousel v-if="data.item.TkPostImage.length != 0"
                                                :interval="0"
                                                controls>
                                                <b-carousel-slide v-for="img in data.item.TkPostImage" :key="img.id"
                                                    img-height="240"
                                                    :img-src="img.src"
                                                ></b-carousel-slide>
                                            </b-carousel>
                                            <span v-else>-</span>
                                        </template>
                                        <template #cell(TkPostName)="data">
                                            <a class="text-primary fw-500 link mr-3" @click="showModal(true, data.item)">
                                                {{data.item.TkPostName}}
                                                <i class="fal fa-pen fs-sm"></i>
                                            </a>
                                            <div v-if="data.item.TkPostDetails != ''">
                                                <span class="fw-400 d-block" style="text-decoration: underline">{{$t('label.details')}}:</span>
                                                <span class="fw-300 text-muted details-overflow">{{data.item.TkPostDetails}}</span>
                                            </div>
                                        </template>
                                        <template #cell(price)="data">
                                            <flag :iso="data.item.DfCurrencyID == 1 ? 'my' : 'sg'" class="mr-1"/>{{data.item.DfCurrencyID == 1 ? 'MYR' : 'SGD'}}
                                            <span class="mb-0 mr-2 fw-400 d-block">{{data.item.price}}</span>
                                            <span v-if="data.item.TkPostDiscount != '0'&& data.item.TkPostDiscount != '0.00'"  class="mb-0 text-secondary fw-300 fs-xs" style="text-decoration: line-through">{{data.item.TkPostPrice}}</span>
                                        </template>
                                        <template #cell(TkPostDuration)="data">
                                            <span class="badge badge-warning"><i class="fal fa-clock mr-1"></i>{{getDuration(data.item.TkPostDuration)}}</span>
                                        </template>
                                        <template #cell(TkPostTotalView)="data">
                                            <div class="text-dark fw-300 mb-1"><i class="fas fa-eye text-secondary mr-1"></i>{{data.item.TkPostTotalView}}</div>
                                        </template>
                                        <template #cell(action)="data">
                                            <a class="text-primary link" title="Delete Reward" @click="showDeleteModal(data.item.TkPostID, data.item.TkPostName)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{isEdit? $t('header.edit') : $t('header.add')}}{{$t('header.post')}}
                            <small v-if="isEdit" class="m-0 text-muted">{{$t('header.post')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="returnPostList">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <tukangPostForm ref="tukangPostForm" @returnPostList="returnPostList"></tukangPostForm>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': messageModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit')}}{{$t('subMenu.my_salon_message')}}
                        </h5>
                        <button type="button" class="close" @click="returnPostList">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <messageForm ref="messageForm" :isThirdLevel="true"  @returnParent="returnPostList"></messageForm>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deletePost"></deleteModal>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import MessageForm from './../message/Message_Form.vue'
import DeleteModal from './../../Delete_Modal'
import DateRangePicker from 'vue2-daterange-picker'
import TukangPostForm from './Tukang_Post_Form'
import {formatPrice, formatTime} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired, getCategoryText} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'tukangPost',
    props:{
        category: Array
    },
    components:{
        DateRangePicker, TukangPostForm, DeleteModal,
        MessageForm
    },
    data(){
        let now = moment();
        let startDate = now.startOf('month').toDate();
        let endDate = now.endOf('month').toDate()
        return{
            isEdit: false,
            isSpinnerShow: false,
            toggleModal: false,
            messageModal: false,
            selectedDateFilter: 'all',
            selectedTab: 'all',
            postCategory: [{id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')})}],
            allPostType: [],
            postType: [],
            selectedType: {},
            stylist: [],
            selectedStylist: {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})},
            posts: [],
            selectedPost: {id: 'all', title: this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})},
            dateRange: { startDate, endDate },
            postItems: [],
            selectedSortOption: {},
            totalEntries: 0, 
            sTitle: "", 
            postID: 0,
        }
    },
    computed:{
        radDateFilter(){
            return[
                { "text": this.$i18n.t('label.all', {'item': ''}), "value": "all" },
                { "text": this.$i18n.t('tukang.post_date'), "value": "create" },
            ]
        },
        sortOption(){
            return this.$i18n.messages[this.$i18n.locale].tukang.post_sort_option
        },
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TkPostCreateDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "message", label: this.$i18n.t('subMenu.my_salon_message'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
                { key: "TkPostImage", label: this.$i18n.t('header.post') + this.$i18n.t('label.image'), thClass: 'thead-themed align-middle', tdClass: 'td-img-width align-middle text-center'},
                { key: "TkPostName", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TkTypeName", label: this.$i18n.t('table.header.type'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TkStylistName", label: this.$i18n.t('tukang.stylist'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TkPostDuration", label: this.$i18n.t('table.header.duration'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                // { key: "TkPostTotalView", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('button_link.view')}), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "action", label: "", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
            ]
        }
    },
    watch:{
        selectedDateFilter(val){
            this.filterPost()
        },
        "$i18n.locale"(val){
            
            this.stylist[0].text = this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})
            var b = Object.assign({}, this.selectedStylist)
            this.selectedStylist = this.stylist.filter(obj=> obj.id == b.id)[0]

            this.posts[0].title = this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})
            var a = Object.assign({}, this.selectedPost)
            this.selectedPost = this.posts.filter(obj=> obj.id == a.id)[0]
        }
    },
    methods:{
        async closeModal(isError){
            if(!isError){
                this.$refs.deleteModal.toggleModal = false
                await this.setPost("")
            }
            this.$parent.$parent.isModalShow = false
        },
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24)
        },
        getDuration(t){
            return formatTime(parseInt(t))
        },
        getDiscountPrice(price, discount){
            var newPrice = parseFloat(price) - parseFloat(discount)
            return formatPrice(newPrice)
        },
        clearFilter(){
            let now = moment();
            let startDate = now.startOf('month').toDate();
            let endDate = now.endOf('month').toDate()
            this.dateRange = {startDate, endDate}
            this.selectedTab = 'all'
            this.selectedDateFilter = 'all'
            this.selectedStylist = {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})}
            this.selectedPost = {id: 'all', title: this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})}

            this.filterPost()
        },
        showModal(isEdit, item){
            this.isEdit = isEdit
            
            this.$refs.tukangPostForm.postType = this.allPostType
            this.$refs.tukangPostForm.editPost(item, this.isEdit)

            if(this.isEdit){
                this.sTitle = item.TkPostName
            }
        },
        sortPost(item){
            this.selectedSortOption = item
            this.filterPost()
        },
        filterByType(item){
            this.selectedType = item
            this.filterPost()
        },
        async filterByCategory(id){
            this.selectedTab = id

            if(this.selectedTab != 'all'){
                this.isSpinnerShow = true
                await this.setType()

                var result = JSON.parse(JSON.stringify(this.postItems))   
                var filtered = []
                var type = this.postType[0].type
                for(var i=1; i<type.length; i++){
                    for(var j=0; j<result.length; j++){
                        if(parseInt(result[j].TkPostTypeID) == type[i].id){
                            filtered.push(result[j])
                        }
                    }
                }
                
                this.postItems = filtered
                this.totalEntries = this.postItems.length
                this.isSpinnerShow = false
            }else{
                this.selectedType = {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('table.header.type')})}
                this.filterPost()
            }         
        },
        filterByDate(date){ 
            date.endDate = moment(date.endDate).endOf('day')
            this.dateRange = date
            this.filterPost()
        },
        filterByStylist(item){
            this.selectedStylist = item
            this.filterPost()
        },
        filterByPost(item){
            this.selectedPost = item
            this.filterPost()
        },
        filterPost(){
            var sortFilter = this.selectedSortOption.id == 'default' ? "" : "&sort=" + this.selectedSortOption.id
            var dateFilter = this.selectedDateFilter == 'all' ? "" : 
            '&startTkPostCreateDate=' + moment(this.dateRange.startDate).unix() + 
            '&endTkPostCreateDate=' + moment(this.dateRange.endDate).unix() 

            var typeFilter = this.selectedType.id == 'all' ? "" : "&TkPostTypeID=" + this.selectedType.id
            var stylistFilter = this.selectedStylist.id == 'all' ? '' : '&TkStylistID=' + this.selectedStylist.id
            var postFilter = this.selectedPost.id == 'all' ? '' : '&TkPostID=' + this.selectedPost.id

            let QUERY_STRING = '?' + dateFilter + typeFilter + stylistFilter + postFilter + sortFilter
            this.setPost(QUERY_STRING)
        },
        setStylistOption(items){
            this.stylist = [{id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})}]
            items.forEach(a => this.stylist.some(b => b.id === a.TkStylistID) || this.stylist.push({id: a.TkStylistID, text: a.TkStylistName}));
        },
        setPostOption(items){
            this.posts = [{id: 'all', title: this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})}]
            items.forEach(a => this.posts.some(b => b.id === a.TkPostID) || this.posts.push(
                {
                    id: a.TkPostID, 
                    title: a.TkPostName,
                    desc: a.TkPostDetails
                }
            ));
        },
        async setType(){
            this.postType = []
            var result = await this.getType()

            var group = _.groupBy(result, 'categoryID');
            for(var id in group){
                var data = {}
                var typeArr = []
                data["category"] = getCategoryText(id, this.postCategory)
                if(this.selectedTab != "all"){
                    typeArr = [{
                        id: "all",
                        text: this.$i18n.t('label.all', {'item': this.$i18n.t('table.header.type')}),
                    }]
                }
                
                for(var i=0; i<group[id].length; i++){
                    typeArr.push({
                        id: group[id][i].typeID,
                        text: group[id][i].type,
                    })
                }
                data["type"] = typeArr;
                this.postType.push(data)
            }
            if(this.selectedTab == "all"){
                this.allPostType = this.postType
                this.selectedType = {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('table.header.type')})}
            }else{
                this.selectedType = this.postType[0].type[0]
            }
        },
        async getType(){
            let $vm = this;
            const url = this.selectedTab == "all" ? this.$api.TUKANG_TYPE : this.$api.TUKANG_CATEGORY + "/" + this.selectedTab + this.$api.TYPE
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        setPostItem(result){
            var items = []
            for(var i=0; i<result.length; i++){
                var image = []
                for(var j=1; j<=6; j++){
                    var key = "TkPostImage" + j
                    if(result[i][key] != ""){
                        image.push({
                            id: key,
                            src: result[i][key],
                            thumbnail: result[i][key],
                        })
                    }
                }
                items.push({
                    TkPostCreateDate: result[i].TkPostCreateDate,
                    staffID: result[i].staffID,
                    TkPostID: result[i].TkPostID,
                    TkPostName:  result[i].TkPostName == "" ? "-" : result[i].TkPostName,
                    TkPostDetails: result[i].TkPostDetails == "" ? "-" : result[i].TkPostDetails,
                    TkPostPrice: result[i].TkPostPrice,
                    TkPostDiscount: result[i].TkPostDiscount,
                    TkPostDuration: result[i].TkPostDuration,
                    TkPostTypeID: result[i].TkPostTypeID,
                    TkPostTotalView: result[i].TkPostTotalView,
                    TkPostImage: image,
                    TkTypeName: result[i].TkTypeName,
                    TkStylistName: result[i].TkStylistName,
                    TkStylistID: result[i].TkStylistID,
                    TkWalkInOnly: result[i].TkWalkInOnly,
                    TkMemberOnly: result[i].TkMemberOnly,
                    DfCurrencyID: result[i].DfCurrencyID,
                    price: this.getDiscountPrice(result[i].TkPostPrice, result[i].TkPostDiscount),
                    TkPostDiscountCode: result[i].TkPostDiscountCode,
                    TkPostDiscountCodeAmt: result[i].TkPostDiscountCodeAmt,
                    TkTaxName: result[i].TkTaxName,
                    TkTaxAmt: result[i].TkTaxAmt,
                    TkVariant1Name: result[i].TkVariant1Name,
                    TkVariant1Amt: result[i].TkVariant1Amt,
                    TkVariant2Name: result[i].TkVariant2Name,
                    TkVariant2Amt: result[i].TkVariant2Amt,
                    TkReqAddr: result[i].TkReqAddr,
                    TkPostUrl: result[i].TkPostUrl,
                    TkPostIdentifier: result[i].TkPostIdentifier,
                    TkCompanyName: result[i].TkCompanyName,
                })
            }
            return items
        },
        async setPost(strFilter){
            this.isSpinnerShow = true
            var res = await this.getPost(strFilter)
            var result = res.result
            this.totalEntries = res.count
            this.postItems = this.setPostItem(result)
            this.postItems.sort((a, b) => b.TkPostCreateDate - a.TkPostCreateDate);

            if(this.selectedStylist.id == 'all'){
                this.setStylistOption(result)
            }
            if(this.selectedPost.id == 'all'){
                this.setPostOption(result)
            }
            this.isSpinnerShow = false
        },
        async getPost(strFilter){
            let $vm = this;
            const url = this.$api.TUKANG_ALL_POST + strFilter
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        showMessageModal(item){
            this.$refs.messageForm.setForm(item.TkPostName, item.TkCompanyName)
            this.messageModal = true
        },
        showDeleteModal(postID, title){
            this.postID = postID
            
            var dTitle = this.$i18n.t('button_link.delete') + this.$i18n.t('header.post')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.delete'), 'item': title})
            this.$refs.deleteModal.showModal(dTitle, message)
        },
        deletePost(){
            let $vm = this
            const url =  $vm.$api.TUKANG_ALL_POST + "/" + this.postID + $vm.$api.DELETE;
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('header.post') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        async returnPostList(){
            this.toggleModal = this.messageModal = false
            await this.setPost("")
        }
    },
    async mounted(){
        let $vm = this
        $vm.postCategory.push(...$vm.category)
        await $vm.setType()
        
        $vm.setPost("")
        $vm.selectedSortOption = $vm.sortOption[0]
    }
}
</script>
<style scoped>
.img-social{
    width: 1.5em;
}
.min-width-20{
    min-width: 20em;
}
.show{
    display: block;
}
.modal-body-lg{
    max-height: 80vh;
    overflow-y: auto;
}
.modal-lg{
    max-width: 75vw;
}
</style>
<style>
.td-img-width{
    width: 15vw !important;
}
</style>